module.exports = __webpack_public_path__ + "img/5.d57daa77.jpg";